import { API, API_GET_ORDER,  } from "../../Config";
import { API_GET } from "../../Config";

export const GetOrder = (usertype) => {
  if (usertype) {
    return API_GET_ORDER(API.GetOrder,usertype);
  } else {
    return API_GET(API.GetOrder);
  }
};
